import React from 'react';
import { Box, Flex, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { useAuth } from 'contexts/AuthContext';

export const LEDGER_META = {
  primary: {
    id: 'primary',
    short: 'V1',
    name: 'Оригинал',
    color: '#0D9488',
  },
  mirror: {
    id: 'mirror',
    short: 'V2',
    name: 'Зеркало',
    color: '#7C3AED',
  },
};

export function useActiveLedger() {
  const { user } = useAuth();
  const activeLedger = user?.activeLedger || user?.active_ledger || 'primary';
  const canSee = !!(
    user?.isDirector ||
    user?.role === 'director' ||
    user?.isAdmin ||
    user?.role === 'admin'
  );
  const theme = LEDGER_META[activeLedger] || LEDGER_META.primary;
  return { activeLedger, canSee, theme };
}

function LedgerDot({ meta, active }) {
  const idle = useColorModeValue('blackAlpha.200', 'whiteAlpha.300');

  return (
    <Tooltip label={`${meta.short} · ${meta.name}`} hasArrow placement="bottom" openDelay={400}>
      <Box
        w={active ? '12px' : '9px'}
        h={active ? '12px' : '9px'}
        borderRadius="full"
        bg={active ? meta.color : idle}
        boxShadow={active ? `0 0 0 4px ${meta.color}22, 0 0 10px ${meta.color}55` : 'none'}
        transition="all 180ms ease"
        aria-hidden
      />
    </Tooltip>
  );
}

export function LedgerSystemIndicator({ variant = 'chip' }) {
  const { activeLedger, canSee, theme } = useActiveLedger();
  const chipBg = useColorModeValue('white', 'navy.800');
  const chipBorder = useColorModeValue(`${theme.color}33`, `${theme.color}66`);

  if (!canSee) return null;

  return (
    <Flex
      role="status"
      aria-label={`Текущая система: ${theme.short} ${theme.name}`}
      align="center"
      gap="8px"
      px={variant === 'chip' ? '10px' : '0'}
      py={variant === 'chip' ? '6px' : '0'}
      borderRadius="full"
      bg={variant === 'chip' ? chipBg : 'transparent'}
      border={variant === 'chip' ? '1px solid' : 'none'}
      borderColor={variant === 'chip' ? chipBorder : 'transparent'}
      boxShadow={variant === 'chip' ? `inset 0 0 0 1px ${theme.color}14` : 'none'}
      flexShrink={0}
    >
      <LedgerDot meta={LEDGER_META.primary} active={activeLedger === 'primary'} />
      <LedgerDot meta={LEDGER_META.mirror} active={activeLedger === 'mirror'} />
    </Flex>
  );
}

export default LedgerSystemIndicator;
